<template>
  <div class="d-flex justify-center align-center flex-column">
    <TriangleHeader :title="auctions.cat_title"/>
    <v-progress-circular
        v-if="loading"
        size="30"
        width="4"
        indeterminate
        color="black"
        class="mt-8"
    ></v-progress-circular>
    <div class="mt-16" style="width: 98vw;" v-else>
      <div class="mx-auto text-center mb-10">
        <h5 class="font-weight-bold">
          {{$t('auction_first_description')}}
        </h5>
        <h5 class="font-weight-bold">
          {{$t('auction_second_description')}}
        </h5>
      </div>
      <v-row :class="$vuetify.breakpoint.mdAndDown?'mx-1':'mx-16'">
        <v-col
            style="height: 660px!important;"
            lg="4" xl="4" md="4" cols="12" v-for="(item,index) in auctions.topics" :key="index">
          <AuctionsItem :item="item"/>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import TrendItem from "./components/TrendItem";
import {GET_AUCTIONS} from "../../store/invitedToCooperateManagement/action_type";
import TriangleHeader from "../../components/triangle_header/TriangleHeader";
import AuctionsItem from "./components/AuctionsItem";

export default {
  name: "auctions",
  components: {AuctionsItem, TriangleHeader, TrendItem},
  computed: {
    ...mapState({
      auctions: state => state.invitedToCooperateManagement.auctions,
      loading: state => state.invitedToCooperateManagement.loading,
    })
  },
  methods:{
    getAuctions() {
      this.$store.dispatch(`invitedToCooperateManagement/${GET_AUCTIONS}`);
    },
  },
  created() {
    this.getAuctions();
  }
}
</script>

